import { createSlice, PayloadAction } from '@reduxjs/toolkit';

class MessageModalState {
    title?: string;
    isVisible: boolean;
    body: string;
    onClickOk?: () => void;
}

class OpenModalPayload {
    title?: string;
    onClickOk?: () => void;
    body: string;
}

const initialState = {
    title: null,
    isVisible: false,

    body: '',

    onClickOk() {
        return null;
    },
};

const messageModalSlice = createSlice({
    name: 'messageModal',
    initialState,

    reducers: {
        openModal(state: MessageModalState, action: PayloadAction<OpenModalPayload>) {
            const { title, onClickOk, body } = action.payload;

            state.title = title;
            state.onClickOk = onClickOk;
            state.body = body;
            state.isVisible = true;
        },

        closeModal(state: MessageModalState) {
            const { title, onClickOk, body } = initialState;

            state.isVisible = false;
            state.title = title;
            state.onClickOk = onClickOk;
            state.body = body;

            if (typeof state.onClickOk === 'function') {
                state.onClickOk();
            }
        },
    },
});

export const { openModal, closeModal } = messageModalSlice.actions;

export default messageModalSlice.reducer;
